import { Component, ElementRef, ViewChild, Inject, ɵConsole } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { MchCambioIdEscritura} from './Escritura.model';
import { MchInformacionEscrituraId } from './Escritura.model';

import { OpcionModel } from '../Global/Opcion.model';
import { IfObservable } from 'rxjs/observable/IfObservable';

@Component({
	selector: 'EscrituraIdEdit',
	templateUrl: './EscrituraIdEdit.component.html',
	styleUrls: ['../../../../styles.css']
})


export class EscrituraIdEditComponent {

	public tiposEscrituras: Array<OpcionModel>;
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
	public form: FormGroup;
	public formErrors: any;
	public escritura: MchCambioIdEscritura;
	public bloquearLlaves: boolean = false;
	public bloquearLlavesDescripcion: boolean = false;
	public guardando: boolean = false;
	public ccodconTemp: string = '';
	public cnumcontTemp: string = '';
	public ciddocTemp: string = '';
	public banderaEditar:  boolean = false;

	public ocultar: boolean = false;
	public mensaje: string = "";


	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.snackBar.dismiss();
		
		this.formErrors = {
			vidEscritura:{},
			vidEscrituraNuevo:{},
			vobservacion:{}
		};
		this.escritura = new MchCambioIdEscritura(new MchInformacionEscrituraId("","",""),"","");
	}
	

	ngOnInit() {
		this.inicializarFormulario("", "", "");

		this._route.params.subscribe(params => {

			this.ccodconTemp = params['vidEscritura'];
			this.cnumcontTemp = params['cnumcont'];
			this.ciddocTemp = params['cprefijo'];

			if (params['editar'] == 0) {
				console.log("entro edit 0");
				this.inicializarFormulario("", "", "");
				this.escritura = new MchCambioIdEscritura(new MchInformacionEscrituraId(params['vidEscritura'],params['cnumcont'], params['cprefijo']),"","");
			} else if (params['editar'] == 1) {
				console.log("entro edit 1");
				this.bloquearLlaves = true;
				this.banderaEditar = true;
				this.escritura = new MchCambioIdEscritura(new MchInformacionEscrituraId(params['vidEscritura'],params['cnumcont'], params['cprefijo']),"","");
				this.inicializarFormulario("", this.ccodconTemp,"");
			}
		});
	}


	

	guardar() {
		
		if( Number(this.escritura.vidEscrituraNuevo) <= 0){
			this.openSnackBarEspecial("El campo Id Escritura Nuevo no puede estar vacio.", "X");
			return;
		}
		if(this.escritura.vobservacion.trim()==''){
			this.openSnackBarEspecial("El campo Observaciones no puede estar vacio.", "X");
			return;
		}
		
		if (this.form.valid == false) {
			this.openSnackBarEspecial("Hay campos obligatorios por llenar...", "X");
			return;
		}
		if (this.banderaEditar) {

						this.guardando = true;
						this._serviciosGenerales.post('guardar/escrituraid', this.escritura).subscribe(result => {
							this.openSnackBar("Cambio ID Escritura Guardada correctamente", "X");
							
							setTimeout(() => {
								this._router.navigate(['/Escritura', this.cnumcontTemp, this.ciddocTemp]);
							}, 2000)		
						}, error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBarEspecial("Ocurrió un error al momento de guardar la Escritura", "X");
							this.guardando = false;
						})
				
				
		}
	}

	inicializarFormulario(valor1, valor2, valorDescripcion) {
		this.form = this.formBuilder.group({
			vidEscritura: [{ disabled: this.bloquearLlaves, value: valor2 }, Validators.required],
			vidEscrituraNuevo: ['', Validators.required],
			vobservacion: ['', Validators.required]
		});
	}

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}






// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CrearEscritura/EscrituraIdEdit.component.ts